import { Box, Button, Flex, LabelledCheckbox, Text } from '@modusign/design-system';

import { Survey } from '@app/containers/Modal/WelcomeSurveyModal';
import { JOB_ROLES } from '@app/containers/Modal/WelcomeSurveyModal/fixtures';

interface JobRoleStepMobileProps {
  nextStep: () => void;
  survey: Survey;
  setSurvey: (update: (survey: Survey) => Survey) => void;
}

function JobRoleStepMobile({ nextStep, survey, setSurvey }: JobRoleStepMobileProps) {
  const isFormValid = !!survey.jobRole.length;

  function handleCheckboxOnChange(value: string) {
    setSurvey((prev) => {
      if (prev.jobRole.includes(value)) {
        return { ...prev, jobRole: prev.jobRole.filter((v) => v !== value) };
      }
      return { ...prev, jobRole: [...prev.jobRole, value] };
    });
  }

  return (
    <>
      <Box fontSize={2} fontWeight="medium" mt={2}>
        입력하신 정보에 맞게 모두싸인을 설정해 드릴게요.
      </Box>
      <Box mt={8}>
        <Box>
          <Text fontWeight="medium">회사 내 역할</Text>{' '}
          <Text color="textNeutralLight">(복수 선택 가능)</Text>
        </Box>
        <Box mt={3}>
          {JOB_ROLES.map(({ title, value }) => (
            <LabelledCheckbox
              checked={survey.jobRole.includes(value)}
              id={value}
              key={value}
              variant="medium"
              onChange={() => handleCheckboxOnChange(value)}
            >
              {title}
            </LabelledCheckbox>
          ))}
        </Box>
        <Flex alignItems="center" justifyContent="end" mt={9}>
          <Button disabled={!isFormValid} ml={6} variant="primary" onClick={nextStep}>
            다음
          </Button>
        </Flex>
      </Box>
    </>
  );
}

export default JobRoleStepMobile;
